<template>
  <div>
    <div class="d-flex align-items-center mb-4">
      <div>
        <h4 class="fw-bold mb-0"><i class="fas fa-power-off me-2 text-danger"></i>Kill Switch</h4>
        <p class="text-muted small mb-0 mt-1">
          Emergency halt — stops all trading and liquidates all open positions immediately.
        </p>
      </div>
    </div>
    <KillSwitchPanel @status-changed="onStatusChanged" />
  </div>
</template>

<script>
import KillSwitchPanel from '../components/KillSwitchPanel.vue';

export default {
  name: 'KillSwitchView',
  components: { KillSwitchPanel },
  methods: {
    onStatusChanged(active) {
      console.log(`[KillSwitchView] Kill switch status changed — active: ${active}`);
    },
  },
};
</script>
